import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import Sidebar from "../../sidebar/sidebar";
import axios from "axios";
import { BaseUrl, ImageBaseUrl } from "../../../Environment";
import { getSecureItem } from "../../../utilsFunctions";
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Stack,
    Avatar,
    Grid,
    Tooltip,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Paper,
    TextField,
    IconButton,
    Typography,
    Snackbar,
    Alert,
    Pagination,
    Toolbar,
    InputBase,
    Menu,
    MenuItem,
    AppBar,
} from "@mui/material";
import { DeleteSharp, EditSharp } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import moment from "moment";
import LoadingPage from "../../modals/LoadingPage/LoadingPage";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
    editwhite,
    deletewhite,
    userdefault,
    plusgreen,
    searchicon,
    plusicon,
} from "../../../assets/images";
import "./viewInvestor.scss";
import { companylogo } from "../../../assets/images";

const menuItemStyle = {
    listStyleType: "none",
    padding: "13px",
    textAlign: "left",
    background: "#50648c",
    position: "relative",
    color: "#fff",
    fontWeight: 500,
    cursor: "pointer",
};

const subMenuStyle = {
    display: "none",
    position: "absolute",
    top: "0",
    left: "220px",
    width: "200px",
    background: "#50648c",
    paddingInlineStart: "0px",
    zIndex: 1000,
};

const subMenuItemStyle = {
    listStyleType: "none",
    padding: "13px 15px",
    cursor: "pointer",
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#e1f0fa",
        color: theme.palette.common.black,
        fontWeight: "bold",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const ROWS_PER_PAGE = 10;

const repaymentTableHeader = {
    sno: "S.No",
    transactionDate: "Date",
    amount: "Amount",
    note: "Note",
    actions: "Actions",
};

const SORTABLE_KEYS = ["transactionDate", "amount"];

class ViewInvestor extends Component {
    state = {
        investors: [],
        loading: true,
        error: null,
        totalAmount: 0,

        search: "",
        investorSortKey: "createdAt",
        investorSortDir: "DESC",
        anchorEl: null,

        repaymentModal: false,
        repaymentData: [],
        repaymentTotal: 0,
        repaymentTotalPages: 1,
        selectedInvestor: null,

        selectedDate: "",
        repaymentAmount: "",
        repaymentNote: "",
        isEditing: false,
        editTransactionId: null,

        deleteModal: false,
        deleteTransactionId: null,

        sortConfig: { key: "transactionDate", direction: "desc" },
        page: 1,

        snackbar: { open: false, msg: "", variant: "success" },
    };

    componentDidMount() {
        this.fetchInvestors();
    }

    showToast = (msg, variant = "success") =>
        this.setState({ snackbar: { open: true, msg, variant } });

    hideToast = () =>
        this.setState((prev) => ({
            snackbar: { ...prev.snackbar, open: false },
        }));

    fetchInvestors = async () => {
        try {
            const companyId = getSecureItem("loggedinUser")?.companyId;
            const token = getSecureItem("token");

            const response = await axios.post(
                `${BaseUrl}/investor/getInvestor`,
                {
                    sortKey: this.state.investorSortKey,
                    sortDir: this.state.investorSortDir,
                },
                {
                    params: {
                        companyId,
                        name: this.state.search,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            this.setState({
                investors: response.data?.investors || [],
                totalAmount: Number(response.data?.companyTotal || 0),
                loading: false,
            });
        } catch (error) {
            console.error(error);

            this.setState({
                investors: [],
                totalAmount: 0,
                loading: false,
                error: "Failed to fetch investors",
            });
        }
    };

    searchlist = async (e) => {
        try {
            const value = e.target.value;

            this.setState({
                search: value,
            });

            const companyId = getSecureItem("loggedinUser")?.companyId;
            const token = getSecureItem("token");

            const response = await axios.post(
                `${BaseUrl}/investor/getInvestor`,
                {
                    sortKey: this.state.investorSortKey,
                    sortDir: this.state.investorSortDir,
                },
                {
                    params: {
                        companyId,
                        name: value,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            this.setState({
                investors: response.data?.investors || [],
                totalAmount: Number(response.data?.companyTotal || 0),
            });
        } catch (error) {
            console.error(error);
        }
    };

    updateInvestorSort = async (sortKey, sortDir) => {
        try {
            const companyId = getSecureItem("loggedinUser")?.companyId;
            const token = getSecureItem("token");

            const response = await axios.post(
                `${BaseUrl}/investor/getInvestor`,
                {
                    sortKey,
                    sortDir,
                },
                {
                    params: {
                        companyId,
                        name: this.state.search,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            this.setState({
                investors: response.data?.investors || [],
                totalAmount: Number(response.data?.companyTotal || 0),
                investorSortKey: sortKey,
                investorSortDir: sortDir,
                anchorEl: null,
            });
        } catch (error) {
            console.error(error);
        }
    };

    handleEditInvestor = (investor) => {
        this.props.history.push({ pathname: "/addInvestor", state: { investor } });
    };

    handleDeleteInvestor = async (investorId) => {
        if (!window.confirm("Are you sure you want to delete this investor?"))
            return;
        try {
            const token = getSecureItem("token");
            const response = await axios.delete(
                `${BaseUrl}/investor/deleteInvestor/${investorId}`,
                { headers: { Authorization: `Bearer ${token}` } },
            );
            if (response.data?.status) {
                this.showToast("Investor deleted successfully");
                this.fetchInvestors();
            } else {
                this.showToast("Error deleting investor", "error");
            }
        } catch (err) {
            console.error(err);
            this.showToast("Error deleting investor", "error");
        }
    };

    getRepayments = async (
        investor,
        page = 1,
        sortConfig = this.state.sortConfig,
    ) => {
        try {
            const token = getSecureItem("token");
            const { key, direction } = sortConfig;

            const response = await axios.get(
                `${BaseUrl}/investor/getInvestmentTransactions`,
                {
                    params: {
                        investorId: investor.investorId,
                        page,
                        limit: ROWS_PER_PAGE,
                        sortKey: key,
                        sortDir: direction,
                    },
                    headers: { Authorization: `Bearer ${token}` },
                },
            );

            this.setState({
                repaymentModal: true,
                repaymentData: response.data?.data || [],
                repaymentTotal: response.data?.total || 0,
                repaymentTotalPages: response.data?.totalPages || 1,
                selectedInvestor: investor,
                page,
                sortConfig,
            });
        } catch (error) {
            console.error(error);
            this.showToast("Failed to fetch repayments", "error");
        }
    };

    handleSort = (key) => {
        if (!SORTABLE_KEYS.includes(key)) return;
        const { sortConfig, selectedInvestor } = this.state;
        const direction =
            sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
        this.getRepayments(selectedInvestor, 1, { key, direction });
    };

    handlePageChange = (_, newPage) => {
        this.getRepayments(
            this.state.selectedInvestor,
            newPage,
            this.state.sortConfig,
        );
    };

    repayInterest = async () => {
        try {
            const token = getSecureItem("token");
            const loggedinUser = getSecureItem("loggedinUser");
            const {
                repaymentAmount,
                repaymentNote,
                selectedDate,
                selectedInvestor,
                isEditing,
                editTransactionId,
                page,
                sortConfig,
            } = this.state;

            if (!repaymentAmount)
                return this.showToast("Please enter amount", "error");

            const payload = {
                investorId: selectedInvestor.investorId,
                amount: Number(repaymentAmount),
                note: repaymentNote || "Interest Repayment",
                transactionDate: selectedDate ? new Date(selectedDate) : new Date(),
                transactionStatus: 1,
                companyId: loggedinUser.companyId,
                updatedByUserId: loggedinUser.userId,
            };

            if (isEditing) {
                payload.transactionId = editTransactionId;
                await axios.put(
                    `${BaseUrl}/investor/putInvestmentTransactions`,
                    payload,
                    { headers: { Authorization: `Bearer ${token}` } },
                );
                this.showToast("Repayment updated successfully");
            } else {
                payload.createdByUserId = loggedinUser.userId;
                payload.companyId = loggedinUser.companyId;
                payload.branchId = loggedinUser.branchId;
                await axios.post(
                    `${BaseUrl}/investor/postInvestmentTransactions`,
                    payload,
                    { headers: { Authorization: `Bearer ${token}` } },
                );
                this.showToast("Repayment added successfully");
            }

            this.setState({
                repaymentAmount: "",
                repaymentNote: "",
                selectedDate: "",
                isEditing: false,
                editTransactionId: null,
            });

            this.getRepayments(selectedInvestor, page, sortConfig);
        } catch (error) {
            console.error(error);
            this.showToast("Failed to save repayment", "error");
        }
    };

    handleEditRepayments = (repayment) => {
        this.setState({
            isEditing: true,
            editTransactionId: repayment.transactionId,
            repaymentAmount: repayment.amount || "",
            repaymentNote: repayment.note || "",
            selectedDate: repayment.transactionDate
                ? moment(repayment.transactionDate).format("YYYY-MM-DD")
                : "",
        });
    };

    cancelEditRepayment = () => {
        this.setState({
            isEditing: false,
            editTransactionId: null,
            repaymentAmount: "",
            repaymentNote: "",
            selectedDate: "",
        });
    };

    handleDeleteRepayments = (transactionId) => {
        this.setState({ deleteModal: true, deleteTransactionId: transactionId });
    };

    confirmDeleteRepayment = async () => {
        try {
            const token = getSecureItem("token");
            const { deleteTransactionId, selectedInvestor, page, sortConfig } =
                this.state;

            await axios.delete(
                `${BaseUrl}/investor/deleteInvestmentTransactions?transactionId=${deleteTransactionId}`,
                { headers: { Authorization: `Bearer ${token}` } },
            );

            this.showToast("Deleted Successfully");
            this.setState({ deleteModal: false, deleteTransactionId: null });

            const newPage =
                this.state.repaymentData.length === 1 && page > 1 ? page - 1 : page;
            this.getRepayments(selectedInvestor, newPage, sortConfig);
        } catch (error) {
            console.error(error);
            this.showToast("Failed to delete", "error");
        }
    };

    CardOver = (index) => {
        const el = document.getElementById("handset" + index);
        const wel = document.getElementById("whitehandset" + index);
        if (el) el.style.display = "none";
        if (wel) wel.style.display = "inline";
    };

    CardOut = (index) => {
        const el = document.getElementById("handset" + index);
        const wel = document.getElementById("whitehandset" + index);
        if (el) el.style.display = "inline";
        if (wel) wel.style.display = "none";
    };

    render() {
        const {
            investors,
            loading,
            error,
            totalAmount,
            snackbar,
            sortConfig,
            page,
            repaymentData,
            repaymentTotalPages,
        } = this.state;
        const { t } = this.props;

        if (loading) return <LoadingPage isLoading={loading} />;
        if (error) return <p style={{ padding: 20, color: "red" }}>{error}</p>;

        return (
            <>
                <Sidebar />

                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={3000}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    onClose={this.hideToast}
                >
                    <Alert
                        onClose={this.hideToast}
                        severity={snackbar.variant}
                        variant="filled"
                        sx={{ width: "100%" }}
                    >
                        {snackbar.msg}
                    </Alert>
                </Snackbar>

                <div className="investorHeader">
                    <section className="investorHeaderSection">
                        <AppBar
                            position="static"
                            style={{
                                backgroundColor: "#fff",
                                boxShadow: "none",
                            }}
                        >
                            <Toolbar
                                style={{
                                    display: "flex",
                                    flexDirection: window.innerWidth <= 959 ? "column" : "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "10px 20px",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    style={{
                                        width: window.innerWidth <= 959 ? "100%" : "67%",
                                        textAlign: "left",
                                        paddingLeft: window.innerWidth <= 959 ? "0px" : "4rem",
                                        marginBottom: window.innerWidth <= 959 ? "10px" : "0px",
                                    }}
                                >
                                    <img
                                        src={companylogo}
                                        alt="logo"
                                        style={{
                                            height: "45px",
                                            objectFit: "contain",
                                        }}
                                    />
                                </Typography>

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: window.innerWidth <= 959 ? "90%" : "27%",
                                        backgroundColor: "#EFF2FF",
                                        borderRadius: "8px",
                                        padding: "5px 10px",
                                    }}
                                >
                                    <IconButton aria-label="search">
                                        <img
                                            src={searchicon}
                                            alt="searchicon"
                                            style={{
                                                width: "20px",
                                                height: "20px",
                                            }}
                                        />
                                    </IconButton>

                                    <InputBase
                                        placeholder="Search Investor"
                                        value={this.state.search}
                                        onChange={this.searchlist}
                                        style={{
                                            width: "100%",
                                            fontSize: "15px",
                                        }}
                                    />
                                </div>
                            </Toolbar>
                        </AppBar>
                    </section>

                    <section
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "15px",
                            padding: "20px 40px",
                        }}
                    >
                        <div className="sortDropdown">
                            <button className="sortDropdown__button">Sort By ▸</button>

                            <ul className="sortDropdown__menu">
                                <li className="sortDropdown__item">
                                    Created Date
                                    <ul className="sortDropdown__submenu">
                                        <li
                                            onClick={() =>
                                                this.updateInvestorSort("createdAt", "ASC")
                                            }
                                        >
                                            Ascending
                                        </li>

                                        <li
                                            onClick={() =>
                                                this.updateInvestorSort("createdAt", "DESC")
                                            }
                                        >
                                            Descending
                                        </li>
                                    </ul>
                                </li>

                                <li className="sortDropdown__item">
                                    Name
                                    <ul className="sortDropdown__submenu">
                                        <li
                                            onClick={() =>
                                                this.updateInvestorSort("firstName", "ASC")
                                            }
                                        >
                                            Ascending
                                        </li>

                                        <li
                                            onClick={() =>
                                                this.updateInvestorSort("firstName", "DESC")
                                            }
                                        >
                                            Descending
                                        </li>
                                    </ul>
                                </li>

                                <li className="sortDropdown__item">
                                    Investment Amount
                                    <ul className="sortDropdown__submenu">
                                        <li
                                            onClick={() =>
                                                this.updateInvestorSort("investorAmount", "ASC")
                                            }
                                        >
                                            Ascending
                                        </li>

                                        <li
                                            onClick={() =>
                                                this.updateInvestorSort("investorAmount", "DESC")
                                            }
                                        >
                                            Descending
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                        <Card
                            style={{
                                padding: "20px",
                                minWidth: "280px",
                                borderRadius: "10px",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                            }}
                        >
                            <h2
                                style={{
                                    margin: 0,
                                    fontSize: "20px",
                                    fontWeight: 600,
                                }}
                            >
                                Total Invested Amount
                            </h2>

                            <h1
                                style={{
                                    marginTop: "8px",
                                    fontSize: "28px",
                                    fontWeight: 700,
                                    color: "#2e7d32",
                                }}
                            >
                                {Number(totalAmount).toLocaleString()}
                            </h1>
                        </Card>

                        <Button
                            variant="contained"
                            onClick={() => this.props.history.push("/addInvestor")}
                            style={{
                                textTransform: "capitalize",
                                backgroundColor: "#00D95E",
                                color: "#fff",
                                padding: "8px 18px",
                                borderRadius: "5px",
                                height: "42px",
                                fontWeight: 600,
                            }}
                        >
                            <img
                                src={plusicon}
                                alt="plus"
                                style={{
                                    paddingRight: "8px",
                                }}
                            />
                            Add Investor
                        </Button>
                    </section>
                </div>

                <div className="Allcustomercardviewpage">
                    <Grid
                        container
                        spacing={1}
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(270px, 1fr))",
                        }}
                    >
                        {investors.map((inv, index) => {
                            const percent = inv.investorAmount
                                ? Math.round((inv.investorAmount / totalAmount) * 100)
                                : 0;
                            return (
                                <Grid item key={inv.investorId}>
                                    <Card
                                        className="CardDiv"
                                        onClick={() => this.getRepayments(inv)}
                                        onMouseOver={() => this.CardOver(index)}
                                        onMouseOut={() => this.CardOut(index)}
                                        style={{ height: "100%" }}
                                    >
                                        <CardHeader
                                            avatar={
                                                <Avatar aria-label="investor-avatar">
                                                    <img
                                                        src={
                                                            inv.proofs?.[0]?.proofImagePath
                                                                ? ImageBaseUrl + inv.proofs[0].proofImagePath
                                                                : userdefault
                                                        }
                                                        alt={inv.firstName?.charAt(0)?.toUpperCase()}
                                                        className="cardimage"
                                                        style={
                                                            inv.proofs?.[0]?.proofImagePath
                                                                ? { width: "40px" }
                                                                : { width: "31px" }
                                                        }
                                                    />
                                                </Avatar>
                                            }
                                            action={
                                                <div>
                                                    <Tooltip title="Edit" placement="top">
                                                        <img
                                                            src={editwhite}
                                                            alt="edit"
                                                            className="message"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.handleEditInvestor(inv);
                                                            }}
                                                            style={{ cursor: "pointer", width: 18 }}
                                                        />
                                                    </Tooltip>
                                                    <div style={{ marginTop: 10 }}>
                                                        <Tooltip title="Delete" placement="top">
                                                            <img
                                                                src={deletewhite}
                                                                alt="delete"
                                                                className="message"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.handleDeleteInvestor(inv.investorId);
                                                                }}
                                                                style={{ cursor: "pointer", width: 18 }}
                                                            />
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            }
                                            title={
                                                <div className="NameDiv Fonts">{`${inv.firstName || ""} ${inv.lastName || ""}`}</div>
                                            }
                                            subheader={
                                                <div className="subheadingnameDiv Fonts">
                                                    {inv.mobile || "-"}
                                                </div>
                                            }
                                        />
                                        <CardContent>
                                            <CardHeader
                                                avatar={
                                                    <div
                                                        style={{
                                                            borderRadius: "50%",
                                                            backgroundColor: "transparent",
                                                            width: "53px",
                                                        }}
                                                    >
                                                        <CircularProgressbar
                                                            value={percent}
                                                            text={`${percent}%`}
                                                            styles={buildStyles({
                                                                textColor: "#3E4664",
                                                                pathColor: "#00D95E",
                                                                trailColor: "#D2D2DC",
                                                                textSize: "30px",
                                                            })}
                                                        />
                                                    </div>
                                                }
                                                title={
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <div className="MoneydetailsDiv Fonts">
                                                            {inv.investorAmount !== undefined &&
                                                                inv.investorAmount !== null
                                                                ? `${Number(
                                                                    inv.investorAmount,
                                                                ).toLocaleString()}`
                                                                : "-"}
                                                        </div>
                                                    </div>
                                                }
                                                subheader={
                                                    <div>
                                                        <div className="subheaderDiv">
                                                            <div
                                                                className="subheaderStatus Fonts"
                                                                style={{
                                                                    backgroundColor: "#EDEFFE",
                                                                    color: "#4D66F0",
                                                                }}
                                                            >
                                                                INVESTOR
                                                            </div>
                                                        </div>
                                                        <div
                                                            style={{
                                                                textTransform: "capitalize",
                                                            }}
                                                            className="loantypename Fonts"
                                                        >
                                                            {inv.businessName || "-"}
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        </CardContent>
                                        <CardActions disableSpacing>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    width: "100%",
                                                    marginTop: "5px",
                                                }}
                                            >
                                                <div className="footerDiv2">
                                                    {inv.verified && (
                                                        <img
                                                            src={plusgreen}
                                                            alt="verified"
                                                            style={{ width: 22 }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            );
                        })}
                    </Grid>
                </div>

                <Dialog
                    open={this.state.repaymentModal}
                    fullWidth
                    maxWidth="lg"
                    onClose={() => this.setState({ repaymentModal: false })}
                >
                    <DialogTitle>
                        Repayment History
                        {this.state.selectedInvestor
                            ? ` | ${this.state.selectedInvestor.firstName} ${this.state.selectedInvestor.lastName}`
                            : ""}
                    </DialogTitle>

                    <DialogContent>
                        <Stack direction="row" spacing={2} marginBottom={3} marginTop={1}>
                            <TextField
                                label="Amount"
                                type="number"
                                fullWidth
                                value={this.state.repaymentAmount}
                                onChange={(e) =>
                                    this.setState({ repaymentAmount: e.target.value })
                                }
                            />
                            <TextField
                                label="Date"
                                type="date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={this.state.selectedDate}
                                onChange={(e) =>
                                    this.setState({ selectedDate: e.target.value })
                                }
                            />
                            <TextField
                                label="Note"
                                fullWidth
                                value={this.state.repaymentNote}
                                onChange={(e) =>
                                    this.setState({ repaymentNote: e.target.value })
                                }
                            />
                            <Stack direction="row" spacing={1}>
                                <Button
                                    variant="contained"
                                    color={this.state.isEditing ? "primary" : "success"}
                                    onClick={this.repayInterest}
                                    sx={{ whiteSpace: "nowrap", minWidth: 100 }}
                                >
                                    {this.state.isEditing ? "Update" : "Add"}
                                </Button>
                                {this.state.isEditing && (
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={this.cancelEditRepayment}
                                    >
                                        Cancel
                                    </Button>
                                )}
                            </Stack>
                        </Stack>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }}>
                                <TableHead>
                                    <TableRow>
                                        {Object.entries(repaymentTableHeader).map(
                                            ([key, label]) => (
                                                <StyledTableCell key={key}>
                                                    {SORTABLE_KEYS.includes(key) ? (
                                                        <TableSortLabel
                                                            active={sortConfig.key === key}
                                                            direction={
                                                                sortConfig.key === key
                                                                    ? sortConfig.direction
                                                                    : "asc"
                                                            }
                                                            onClick={() => this.handleSort(key)}
                                                        >
                                                            {label}
                                                        </TableSortLabel>
                                                    ) : (
                                                        label
                                                    )}
                                                </StyledTableCell>
                                            ),
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {repaymentData.map((data, index) => (
                                        <StyledTableRow key={data.transactionId ?? index}>
                                            <StyledTableCell>
                                                {(page - 1) * ROWS_PER_PAGE + index + 1}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {moment(data.transactionDate).format("DD/MM/YYYY")}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {Number(data.amount).toLocaleString()}
                                            </StyledTableCell>
                                            <StyledTableCell>{data.note}</StyledTableCell>
                                            <StyledTableCell>
                                                <Stack direction="row" spacing={1}>
                                                    <IconButton
                                                        color="primary"
                                                        aria-label="edit"
                                                        onClick={() => this.handleEditRepayments(data)}
                                                    >
                                                        <EditSharp />
                                                    </IconButton>
                                                    <IconButton
                                                        color="error"
                                                        aria-label="delete"
                                                        onClick={() =>
                                                            this.handleDeleteRepayments(data.transactionId)
                                                        }
                                                    >
                                                        <DeleteSharp />
                                                    </IconButton>
                                                </Stack>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Pagination
                            count={repaymentTotalPages}
                            page={page}
                            onChange={this.handlePageChange}
                            variant="outlined"
                            shape="rounded"
                            size="large"
                            style={{ marginTop: 12 }}
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => this.setState({ repaymentModal: false })}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.deleteModal}
                    onClose={() => this.setState({ deleteModal: false })}
                >
                    <DialogTitle>Delete Repayment</DialogTitle>
                    <DialogContent>
                        <Typography fontSize={15} variant="h6">
                            Are you sure you want to delete this repayment record?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Stack direction="row" spacing={2}>
                            <Button
                                variant="outlined"
                                onClick={() => this.setState({ deleteModal: false })}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="error"
                                variant="contained"
                                onClick={this.confirmDeleteRepayment}
                            >
                                Delete
                            </Button>
                        </Stack>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default withNamespaces()(ViewInvestor);
